export default "__VITE_ASSET__$joeXIX1__"